import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { ReactNode } from "react";

interface OneTimeSeatWarningDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  variant?: "assign" | "unassign";
  children?: ReactNode;
}

const AssignMessage = () => (
  <>
    <Typography gutterBottom fontWeight="bold">
      This is a Disposable License
    </Typography>
    <Typography gutterBottom>
      You are about to assign a seat from a disposable license pool. Once a seat
      is assigned, it is permanently consumed.
    </Typography>
    <Typography gutterBottom color="warning.main">
      ⚠ This seat cannot be reused or transferred after assignment — not even if
      the user leaves.
    </Typography>
    <Typography gutterBottom>
      Are you sure you want to continue? This action cannot be undone.
    </Typography>
  </>
);

const UnassignMessage = () => (
  <>
    <Typography gutterBottom>
      This will remove the user's seat permanently. That seat will not return to
      the license pool and cannot be reused or reassigned.
    </Typography>
    <Typography gutterBottom>This action cannot be undone.</Typography>
  </>
);

const DefaultMessage = () => (
  <>
    <Typography gutterBottom>
      One or more selected services use one-time seats.
    </Typography>
    <Typography gutterBottom>
      Once a seat is assigned or unassigned, the action cannot be undone.
    </Typography>
    <Typography gutterBottom>Are you sure you want to continue?</Typography>
  </>
);

export const OneTimeSeatWarningDialog = ({
  open,
  onClose,
  onConfirm,
  variant,
  children,
}: OneTimeSeatWarningDialogProps) => (
  <Dialog open={open} onClose={onClose}>
    <DialogTitle>One-Time Seat Warning</DialogTitle>
    <DialogContent dividers>
      {children ??
        (variant === "assign" ? (
          <AssignMessage />
        ) : variant === "unassign" ? (
          <UnassignMessage />
        ) : (
          <DefaultMessage />
        ))}
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose}>Cancel</Button>
      <Button onClick={onConfirm} color="warning" variant="contained">
        Continue
      </Button>
    </DialogActions>
  </Dialog>
);
